/** Resume visual / export layout variants */
export type ResumeTemplateId = 'classic' | 'two_column'

export const RESUME_TEMPLATES: Array<{
  id: ResumeTemplateId
  label: string
  description: string
}> = [
  {
    id: 'classic',
    label: 'Classic',
    description: 'Single column: name and contact on top, experience and other sections below',
  },
  {
    id: 'two_column',
    label: 'Two-Column',
    description:
      'Two columns: centered name and contact; experience and projects on the left; skills, education, and certifications on the right',
  },
]

export const DEFAULT_RESUME_TEMPLATE: ResumeTemplateId = 'classic'

const STORAGE_KEY = 'applicator-resume-template'

/** @deprecated stored preference from older builds */
const LEGACY_TEMPLATE_ID_PAYSAFE = 'paysafe'

export function normalizeResumeTemplateId(value: string | null): ResumeTemplateId | null {
  if (value === LEGACY_TEMPLATE_ID_PAYSAFE) return 'two_column'
  if (value === 'classic' || value === 'two_column') return value
  return null
}

export function loadResumeTemplatePreference(): ResumeTemplateId {
  try {
    const normalized = normalizeResumeTemplateId(localStorage.getItem(STORAGE_KEY))
    if (normalized) return normalized
  } catch {
    /* ignore */
  }
  return DEFAULT_RESUME_TEMPLATE
}

export function saveResumeTemplatePreference(id: ResumeTemplateId): void {
  try {
    localStorage.setItem(STORAGE_KEY, id)
  } catch {
    /* ignore */
  }
}
